import React, { useCallback, useEffect, useState } from "react";
import "./RoofTypeTab.css";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import Text from "src/components/Text/Text";
import RadioBlocksExtended from "src/components/Input/RadioBlocksExtended/RadioBlocksExtended";
import { useView } from "src/contexts/ViewContext";
import Number from "src/components/Input/Number/Number";
// @ts-ignore
import { debounce, isEqual } from "lodash";
import useCalculationService from "src/hooks/useCalculationService";
import HorizontalSwitch from "src/components/Input/HorizontalSwitch/HorizontalSwitch";
import SelectUnselectExtended from "src/components/SelectUnselectExtended/SelectUnselectExtended";

export const roofTypes = [
  {
    id: 1,
    name: "Classic",
    imageUrl: `${process.env.PUBLIC_URL}/images/ver_oase_roof.png`,
    color: "",
    value: "oase",
    price: 0,
    // description:
    //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: 0,
    name: "Cube",
    imageUrl: `${process.env.PUBLIC_URL}/images/ver_aludra_roof.png`,
    color: "",
    value: "aludra",
    // price: useCalculationService.getPoer(),
    // description:
    //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
];

export const guuters = [
  {
    id: 0,
    name: "Modern strak",
    value: "default",
    price: 0,
    imageUrl: `${process.env.PUBLIC_URL}/images/ver_gutter_default.png`,
    // description:
    //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: 1,
    name: "Klassiek rond",
    value: "rond",
    price: 0,
    imageUrl: `${process.env.PUBLIC_URL}/images/ver_gutter_rond.png`,
    // description:
    //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  // {
  //   id: 2,
  //   name: "Modern strak met strepen",
  //   value: "klassiek",
  //   price: 0,
  //   imageUrl: `${process.env.PUBLIC_URL}/images/ver_gutter_klasik.png`,
  //   description:
  //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  // },
];

const RoofTypeTab: React.FC = () => {
  const {
    state,
    setRoofType,
    setDimensions,
    setSpy,
    setGutter,
    configuration,
  } = useConfiguration();

  const [gutterOppened, setGutterOppened] = useState(false);

  //i have tryied, you can try as well
  // roofTypes.map((i) => {
  //   i.price = configuration.calculationService.getRoof(i.value);
  // });

  let oaseOffset =
    (Math.tan((8 * Math.PI) / 180) * (state.dimensions.depth / 1000 - 0.11) +
      0.17) *
    1000;

  oaseOffset = Math.ceil(oaseOffset / 10) * 10;
  // oaseOffset = oaseOffset - (oaseOffset % 10);

  const handleRoofTypeChange = (roofType: string) => {
    if (state.roofType !== roofType) setRoofType(roofType);
  };

  const handleGooter = (value: string) => {
    if (state.gutter.type === value) return;
    setGutter({ ...state.gutter, type: value });
  };

  const handleFrontLimit = (value: string) => {
    const parsedValue = parseInt(value, 10);
    if (isNaN(parsedValue) || parsedValue < 4000 || parsedValue > 6000) {
      return;
    }
    if (state.dimensions.frontlimit === parsedValue) return;
    setDimensions({ ...state.dimensions, frontlimit: parsedValue });
  };

  const LRIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none">
      <g clip-path="url(#a)">
        <path
          fill="#5B5B5D"
          d="m1.881 20.951.007-9.108 16.028.023-3.6 3.911a.956.956 0 0 0-.235.64c.002.24.089.468.244.637.155.17.364.265.583.268a.8.8 0 0 0 .588-.255l4.14-4.5a2.3 2.3 0 0 0 .455-.737 2.459 2.459 0 0 0 .002-1.743 2.3 2.3 0 0 0-.452-.74l-4.13-4.514a.803.803 0 0 0-.592-.267.804.804 0 0 0-.592.267.955.955 0 0 0-.245.645c0 .242.088.474.245.645l3.588 3.921-16.024-.023.007-9.108A.954.954 0 0 0 1.654.27a.802.802 0 0 0-.59-.268.802.802 0 0 0-.592.266.954.954 0 0 0-.246.644L.21 20.949c0 .241.087.473.244.644a.803.803 0 0 0 .59.268.803.803 0 0 0 .592-.266.954.954 0 0 0 .245-.644Z"
        />
      </g>
      <g clip-path="url(#b)">
        <path
          fill="#5B5B5D"
          d="m20.288 1.042-.028 9.108-16.013-.092L7.86 6.162c.153-.17.238-.4.238-.639a.954.954 0 0 0-.241-.637.802.802 0 0 0-.582-.27.8.8 0 0 0-.589.252l-4.155 4.48a2.3 2.3 0 0 0-.457.737 2.457 2.457 0 0 0-.01 1.743 2.3 2.3 0 0 0 .448.741l4.108 4.533a.802.802 0 0 0 .59.27.803.803 0 0 0 .592-.265.956.956 0 0 0 .248-.644.956.956 0 0 0-.242-.646L4.24 11.88l16.01.092-.029 9.108a.954.954 0 0 0 .24.645.802.802 0 0 0 .59.27.802.802 0 0 0 .592-.263.954.954 0 0 0 .248-.643l.067-20.037a.954.954 0 0 0-.24-.646.801.801 0 0 0-.59-.27.801.801 0 0 0-.592.264.954.954 0 0 0-.248.642Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="m20.984.03-.03 21.859L0 21.859.031 0z" />
        </clipPath>
        <clipPath id="b">
          <path fill="#fff" d="M.014 21.875.139.016 22 .141l-.125 21.86z" />
        </clipPath>
      </defs>
    </svg>
  );

  const TBIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none">
      <g clip-path="url(#a)">
        <path
          fill="#5B5B5D"
          d="m20.95 20.119-9.107-.007.023-16.028 3.911 3.6a.956.956 0 0 0 .64.235.953.953 0 0 0 .637-.244.803.803 0 0 0 .268-.583.8.8 0 0 0-.255-.588l-4.5-4.14a2.3 2.3 0 0 0-.737-.455 2.455 2.455 0 0 0-1.743-.002 2.3 2.3 0 0 0-.74.452l-4.514 4.13a.803.803 0 0 0-.267.592c0 .222.096.435.267.592a.955.955 0 0 0 .645.245.955.955 0 0 0 .645-.245l3.921-3.588-.023 16.024-9.107-.007a.954.954 0 0 0-.645.244.803.803 0 0 0-.267.59c0 .223.095.435.266.592.17.157.402.246.643.246l20.037.016a.953.953 0 0 0 .645-.244.803.803 0 0 0 .267-.59.802.802 0 0 0-.265-.592.954.954 0 0 0-.644-.245Z"
        />
      </g>
      <g clip-path="url(#b)">
        <path
          fill="#5B5B5D"
          d="m1.043 1.712 9.107.028-.091 16.013-3.896-3.613a.957.957 0 0 0-.64-.238.953.953 0 0 0-.637.24.802.802 0 0 0-.27.582.8.8 0 0 0 .252.59l4.481 4.155c.21.195.46.35.736.457a2.46 2.46 0 0 0 1.743.01c.277-.103.53-.256.742-.448l4.532-4.108a.802.802 0 0 0 .27-.59.802.802 0 0 0-.265-.592.956.956 0 0 0-.644-.248.955.955 0 0 0-.646.242L11.88 17.76l.092-16.01 9.108.029a.954.954 0 0 0 .645-.241.801.801 0 0 0 .27-.59.801.801 0 0 0-.263-.591.954.954 0 0 0-.642-.248L1.052.042a.954.954 0 0 0-.645.24.801.801 0 0 0-.27.59.801.801 0 0 0 .263.591c.17.158.401.247.643.249Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="m.03 1.016 21.86.03L21.86 22 0 21.969z" />
        </clipPath>
        <clipPath id="b">
          <path fill="#fff" d="M21.875 21.986.016 21.861.142 0 22 .125z" />
        </clipPath>
      </defs>
    </svg>
  );

  const { isAdmin } = useView();

  const debouncedSetDimensions = useCallback(
    debounce((dims: any) => {
      setDimensions(dims);
    }, 250),
    [setDimensions]
  );

  useEffect(() => {
    return () => {
      debouncedSetDimensions.cancel();
    };
  }, [debouncedSetDimensions]);

  const handleChangeDimension = (value: number, key: string) => {
    const updatedDimensions = { ...state.dimensions };
    // @ts-ignore
    if (key !== "heightBack") updatedDimensions[key] = value;
    else updatedDimensions["height"] = value - oaseOffset;

    if (isEqual(updatedDimensions, state.dimensions)) return;
    debouncedSetDimensions(updatedDimensions);
  };

  // guuters.map((i) => {
  //   i.price = configuration.calculationService.getGutter(i.value);
  // });

  return (
    <div className="roof-type-tab">
      <RadioBlocksExtended
        blocks={roofTypes}
        value={state.roofType}
        onChange={handleRoofTypeChange}
        className={"inner_child"}
      />
      <Text content="Kies uw afmetingen" />
      <Number
        key={"house-width"}
        value={state.dimensions.width}
        onChange={(value) => handleChangeDimension(value, "width")}
        label="Breedte"
        subStep={10}
        min={3000}
        max={12000}
        step={500}
        unit={"cm"}
        Svg={LRIcon}
      />
      <Number
        key={"house-depth"}
        value={state.dimensions.depth}
        onChange={(value) => handleChangeDimension(value, "depth")}
        label="Diepte"
        subStep={10}
        min={2500}
        max={5000}
        step={500}
        unit={"cm"}
        Svg={TBIcon}
      />
      {state.roofType === "oase" && <Text content="Hoogtes" />}
      <Number
        key={"house-height"}
        value={state.dimensions.height}
        onChange={(value) => handleChangeDimension(value, "height")}
        label={state.roofType === "oase" ? "Voor (doorloop)" : "Doorloophoogte"}
        subStep={10}
        min={2000}
        max={3000}
        step={100}
        unit={"cm"}
        Svg={TBIcon}
      />
      {state.roofType === "oase" && (
        <>
          <Number
            key={"house-back-height"}
            value={state.dimensions.height + oaseOffset}
            onChange={(value) => handleChangeDimension(value, "heightBack")}
            label="Achter (bovenzijde)"
            subStep={10}
            min={2000 + oaseOffset}
            max={3000 + oaseOffset}
            step={100}
            unit={"cm"}
            Svg={TBIcon}
          />
          {/* {state.roofType === "oase" && isAdmin() && (
            <Number
              key={"house-angle"}
              value={state.dimensions.angle}
              onChange={(value) => handleChangeDimension(value, "angle")}
              label="roof angle"
              subStep={1}
              min={5}
              max={10}
              step={2}
              unit={"deg"}
            />
          )} */}
        </>
      )}
      {state.roofType === "oase" && (
        <>
          {/* <Text content="Kies overspanning" />
          <div className="max_span">
            <span>Maximale breedte</span>{" "}
            <HorizontalSwitch
              value={
                state.dimensions.frontlimit
                  ? state.dimensions.frontlimit.toString()
                  : "4000"
              }
              values={[
                { id: 0, label: "4m", value: "4000" },
                { id: 1, label: "5m", value: "5000" },
                { id: 2, label: "6m", value: "6000" },
              ]}
              onChange={handleFrontLimit}
            />
          </div> */}
          <SelectUnselectExtended
            name="Goot-type"
            imageUrl={`${process.env.PUBLIC_URL}/images/ver_gutter_klasik.png`}
            // description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
            isSelected={true}
            onSelect={() => true}
            onUnselect={() => false}
            alwaysShowSelected={true}
            Component={() => (
              <RadioBlocksExtended
                blocks={guuters}
                value={state.gutter.type}
                onChange={handleGooter}
                className={"inner_child"}
              />
            )}
            selectedNames={
              guuters.find((i) => i.value === state.gutter.type)?.name
            }
            carouselImages={guuters.map((i) => i.imageUrl)}
          />
          {/* <RadioBlocksExtended
            blocks={[
              {
                id: 0,
                name: "Gutter types",
                imageUrl: `${process.env.PUBLIC_URL}/images/ver_gutter_klasik.png`,
                value: " ",
                description:
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                component: () => (
                  <RadioBlocksExtended
                    blocks={[
                      {
                        id: 0,
                        name: "Recht",
                        value: "default",
                        price:
                          configuration.calculationService.getGutter("default"),
                        imageUrl: `${process.env.PUBLIC_URL}/images/ver_gutter_default.png`,
                        description:
                          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                      },
                      {
                        id: 1,
                        name: "Rond",
                        value: "rond",
                        price:
                          configuration.calculationService.getGutter("rond"),
                        imageUrl: `${process.env.PUBLIC_URL}/images/ver_gutter_rond.png`,
                        description:
                          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                      },
                      {
                        id: 2,
                        name: "Klassiek",
                        value: "klassiek",
                        price:
                          configuration.calculationService.getGutter(
                            "klassiek"
                          ),
                        imageUrl: `${process.env.PUBLIC_URL}/images/ver_gutter_klasik.png`,
                        description:
                          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                      },
                    ]}
                    value={state.gutter.type}
                    onChange={handleGooter}
                    className={"inner_child"}
                  />
                ),
              },
            ]}
            value={""}
            onChange={() => null}
          /> */}
        </>
      )}
    </div>
  );
};

export default RoofTypeTab;
